import { I18NState, resolveTranslation } from "..";

export function __debug() {
  const STATE: I18NState = I18NState.getInstance();
  for (const resolver of STATE.translationResolver) {
    resolveTranslation(resolver.namespace, resolver.language);
  }

  return STATE;
}
